module.exports = {
    //登录
    login:'登录',
    loginByAccount:'账号密码登录',
    inputAccount:'请输入账号',
    inputPassword:'请输入密码',
    verificationCode:'验证码',
    forgotPassword:'忘记密码',
    experience:'免注册体验',
    loginTitle1:'进出仓库方便操作',
    loginTitle2:'单据流程明细准确',
    loginTitle3:'财务管理便捷严谨',
    loginTitle4:'数据展示一目了然',
    lastTime:'上次登录时间',
    waitTodo:'待办事项',
    remember:'记住密码',
    //按钮
    search:'搜索',
    reset:'重置',
    add:'新增',
    save:'保存',
    templateDownload:'模板下载',
    importGoods:'导入商品',
    addGoods:'添加商品',
    edit:'修改',
    delete:'删除',
    copy:'复制',
    examine:'审批',
    revocation:'撤回',
    confirm:'确定',
    inStorage:'入库',
    outStorage:'出库',
    print:'打印',
    exportDocument:'导出单据',
    saveDraft:'保存草稿',
    close:'关闭',
    reject:'驳回',
    createNewProduct:'新建商品',
    approved:'通过',
    historicalSalesPrice:'历史销售价格',
    historicalPurchasePrice:'历史采购价格',
    export:'导出',
    generateInboundOrder:'生成入库单',
    cancle:'取消',
    confirmInbound:'确认入库',
    confirmOutbound:'确认出库',
    EorD:'启用/停用',
    batchImport:'批量导入',
    batchEdit:'批量修改',
    enable:'启用',
    disable:'停用',
    inquiryRecords:'询价记录',
    barcode:'条码',
    //表格
    No:'No.',
    documentNumber:'单号',
    warehouse:'仓库',
    supplier:'供应商',
    supplierInformation: '供应商信息',
    client:'客户',
    commodityAmount:'商品金额',
    otherAmount:'其它金额',
    totalAmount:'合计金额',
    status:'状态',
    createTime:'创建时间',
    completionTime:'完成时间',
    startTime:'开始时间',
    endTime:'结束时间',
    operator:'开单人',
    approver:'审批人',
    deliveryTime:'货期',
    remark:'备注',
    operate:'操作',
    goodsName:'商品名称',
    goodsId:'图号',
    brand:'产地品牌',
    category:'分类',
    select:'请选择',
    amountPayable:'应付金额',
    amountReceivable:'应收金额',
    paymentMethod:'付款方式',
    quantity:'数量',
    unitPrice:'单价',
    amount:'金额',
    storageLocation:'库位',
    unit:'单位',
    internalCode:'内部编码',
    specification:'规格',
    approvalComments:'审批意见',
    details:'详情',
    inventoryQuantity:'库存数量',
    historicalPrice:'历史价格',
    amountPaid:'实付金额',
    creator:'创建人',
    phoneNum:'手机号',
    customerInformation:'客户信息',
    basicInformation:'基本信息',
    contactPerson:'联系人',
    image:'图片',
    retailPrice:'零售价',
    wholesalePrice:'批发价',
    otherPrice:'其他售价',
    foreignName:'外文名称',
    itemLength:'长(mm)',
    itemWide:'宽(mm)',
    itemHigh:'高(mm)',
    itemWeight:'净重(Kg)',
    defectiveQuantity:'坏件量',
    otherOccupation:'其他占用',
    availableQuantity:'可用量',
    changeTime:'变动时间',
    landline:'电话',
    fax:'传真',
    address:'地址',
    bankOfAccount:'开户行',
    bankAccountNumber:'银行账号',
    taxNum:'税号',
    //提示
    operationSuccessful:'操作成功',
    pleaseAddProduct:'请添加商品',
    unitNotBeNull:'数量和单价不能为空',
    quantityNotBeDecimal:'数量不能是小数',
    unitPriceNotBeNegative:'数量为正整数，单价不能为负数',
}